import {
  GET_WORKFLOW_PENDING,
  GET_WORKFLOW_FULFILLED,
  GET_WORKFLOW_REJECTED,
} from "../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: false,
  selected: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_WORKFLOW_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_WORKFLOW_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_WORKFLOW_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
